import { defineStore } from "pinia";
import { ref } from "vue";
import { API } from "@/queries/index";
import { AxiosError } from "axios";
import { APIResponse, APIResponseError } from "@/types/api";
import { handleResponse, handleResponseError } from "@/utils/api";
import { PositionsDataPayload, PositionsDataResponse } from "@/types/interface/position";

export const usePositionStore = defineStore("positionStore", () => {
  const position = ref<PositionsDataResponse>();
  const positions = ref<PositionsDataResponse[]>([]);

  function initPositions(data: any) {
    positions.value = data?.data;
  }

  function addNewPosition(data: any) {
    position.value = data;
  }

  async function dispatchGetPositions(page = 1, limit = 10, queryParam = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.position.getPosition(page, limit, queryParam);
      if (status === 200 ) {
        initPositions(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDetail(idPosition = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.position.findPosition(idPosition);
      if (status === 200 ) {
        addNewPosition(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchCreate(payload: PositionsDataPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.position.createPosition(payload);
      if (status === 200 ) {
        addNewPosition(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchUpdate(idPosition = "", payload: PositionsDataPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.position.updatePosition(idPosition, payload);
      if (status === 200 ) {
        addNewPosition(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDelete(idPosition = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.position.deletePosition(idPosition);
      if (status === 200 ) {
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  return {
    position,
    positions,
    initPositions,
    dispatchCreate,
    dispatchUpdate,
    dispatchDetail,
    dispatchGetPositions,
    dispatchDelete
  };
});